


































































import { Vue, Component } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import ITransformations from '@/store/models/ITransformations';
import TransformationApi from '@/store/api/TransformationApi';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import TransformationsSelector from '../components/selectors/Transformations/TransformationsSelector.vue';
import IListStatusTransformation from '@/store/models/IListStatusTransformation';
import ListStatusTransformationApi from '@/store/api/ListStatusTransformationApi';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '@/store/api/WarehouseApi';
import IStock from '@/store/models/IStock';
import StockApi from '@/store/api/StockApi';
import ITransformationsPalletsSource from '@/store/models/ITransformationsPalletsSource';
import TransformationPalletsSourceApi from '@/store/api/TransformationPalletsSourceApi';
import ITransformationsPalletsDestination from '@/store/models/ITransformationsPalletsDestination';
import TransformationPalletsDestinationApi from '@/store/api/TransformationPalletsDestinationApi';
import IListPalletType from '@/store/models/IListPalletType';
import ListPalletTypesApi from '@/store/api/ListPalletTypesApi';
import ITransformationsProducts from '@/store/models/ITransformationsProducts';
import TransformationsPalletsSelector from '../components/selectors/Transformations/TransformationsPalletsSelector.vue';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import { v4 as uuidv4 } from 'uuid';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        Snackbar,
        TransformationsSelector,
        TransformationsPalletsSelector
    }
})
export default class Transformations extends Vue {
    enableTabsItemTransformation: boolean = false;
    overlay: boolean = false;
    selectedTransformation: ITransformations | null = null;

    transformationApi: TransformationApi;
    listStatusTransformationApi: ListStatusTransformationApi;
    warehouseApi: WarehouseApi;
    stockApi: StockApi;
    transformationPalletsSourceApi: TransformationPalletsSourceApi;
    transformationPalletsDestinationApi: TransformationPalletsDestinationApi;
    listPalletTypesApi: ListPalletTypesApi;
    settingsCompanyApi: SettingsCompanyApi;
    customersApi: CustomerApi;

    companyId: string = "";
    userName: string = "";
    permissions: IRolePermission[] = [];
    transformationList: ITransformations[] = [];
    statusTransformationList: IListStatusTransformation[] = [];
    warehouseList: IWarehouse[] = [];
    stockList: IStock[] = [];
    completedTransformations: boolean = false;
    enableTabsItem: boolean = false;
    activeTab: number = 0;
    idTransformation: string = "";
    transformationPalletsSourceList: ITransformationsPalletsSource[] = [];
    transformationPalletsDestinationList: ITransformationsPalletsDestination[] = [];
    listPalletTypes: IListPalletType[] = [];
    productsTransformationList: ITransformationsProducts[] = [];
    stockListFiltered: IStock[] = [];
    showCustomer: boolean = false;
    CustomerList: ICustomer[] = [];

    // Protección contra doble ejecución
    isEditingTransformation: boolean = false;
    completingTransformationIds: string[] = [];

    get isSuperAdmin() {
        return this.companyId === EMPTY_GUID;
    }

    get TransformationCodeSelected() {
        if (this.selectedTransformation) {
            return "Transformation " + this.selectedTransformation.inboundCode;
        } else {
            return "Transformation";
        }
    }

    get StatusTransformationCompleted() {
        if (!this.statusTransformationList || this.statusTransformationList.length === 0) return "";
        const found = this.statusTransformationList.find(
            s => (s.name || "").toLowerCase() === "completed"
        );
        return found ? found.id : "";
    }

    get HasDetails() {
        return !!(
            this.transformationPalletsDestinationList &&
            this.transformationPalletsDestinationList.length > 0
        );
    }

    constructor() {
        super();
        this.transformationApi = new TransformationApi();
        this.listStatusTransformationApi = new ListStatusTransformationApi();
        this.warehouseApi = new WarehouseApi();
        this.stockApi = new StockApi();
        this.transformationPalletsSourceApi = new TransformationPalletsSourceApi();
        this.transformationPalletsDestinationApi = new TransformationPalletsDestinationApi();
        this.listPalletTypesApi = new ListPalletTypesApi();
        this.settingsCompanyApi = new SettingsCompanyApi("Transformations");
        this.customersApi = new CustomerApi();
    }

    async created() {
        this.overlay = true;
        try {
            await this.getPermissions();
            await Promise.all([
                this.getInbounds(),
                this.getTransformations(),
                this.getStatusTransformation(),
                this.getWarehouses(),
                this.getListPalletTypes(),
                this.getCustomers()
            ]);
        } finally {
            this.overlay = false;
        }
    }

    isTransformationBeingCompleted(transformationId: string): boolean {
        return this.completingTransformationIds.includes(transformationId);
    }

    lockTransformationCompletion(transformationId: string) {
        if (!this.completingTransformationIds.includes(transformationId)) {
            this.completingTransformationIds.push(transformationId);
        }
    }

    unlockTransformationCompletion(transformationId: string) {
        this.completingTransformationIds = this.completingTransformationIds.filter(
            id => id !== transformationId
        );
    }

    async getCustomers() {
        this.CustomerList = await this.customersApi.GetCustomersByCompanyId(this.companyId);
    }

    async getPermissions() {
        const userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userName = userFromStorage.username;

        const permission = userFromStorage.rolePermissions.find(r => r.formName === "Sells");
        if (permission) {
            this.permissions.push(permission);
        }

        const settingsCompany = SettingsCompany.Settings.ShowCustomer;
        const setting: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);

        if (setting.length > 0) {
            this.showCustomer = setting[0].value !== "No";
        }
    }

    async getTransformations() {
        this.transformationList = await this.transformationApi.GetTransformations(this.companyId);
    }

    async getStatusTransformation() {
        this.statusTransformationList = await this.listStatusTransformationApi.GetListStatusTransformation();
    }

    async getWarehouses() {
        this.warehouseList = await this.warehouseApi.GetWarehouses();
    }

    async getInbounds() {
        this.stockList = await this.stockApi.GetInboundsCodeInStock(this.companyId);
    }

    async getTransformationsPalletsSource() {
        if (this.selectedTransformation) {
            this.transformationPalletsSourceList =
                await this.transformationPalletsSourceApi.GetTransformationsPalletsSource(this.selectedTransformation.id);
        }
    }

    async getTransformationsPalletsDestination() {
        if (this.selectedTransformation) {
            this.transformationPalletsDestinationList =
                await this.transformationPalletsDestinationApi.GetTransformationsPalletsDestination(this.selectedTransformation.id);
        }
    }

    async getListPalletTypes() {
        this.listPalletTypes = await this.listPalletTypesApi.GetListPalleTypes();
    }

    async getInboundStock() {
        if (this.selectedTransformation) {
            this.stockListFiltered = await this.stockApi.GetStockByInboundCodeAndWarehouse(
                this.selectedTransformation.inboundCode,
                this.selectedTransformation.idWarehouse
            );
        }
    }

    resetTransformation() {
        this.selectedTransformation = null;
        this.transformationPalletsDestinationList = [];
        this.transformationPalletsSourceList = [];
        this.productsTransformationList = [];
        this.stockListFiltered = [];
        this.enableTabsItemTransformation = false;
        this.idTransformation = "";
        this.activeTab = 0;
        this.enableTabsItem = false;
    }

    async showCompletedTransformation(completedTransformations: boolean) {
        this.overlay = true;
        try {
            if (completedTransformations) {
                this.transformationList = await this.transformationApi.GetTransformationsCompleted(this.companyId);

                if (this.showCustomer === false) {
                    this.transformationList.forEach((i) => {
                        const indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                        if (indexCustomer !== -1) {
                            if (
                                i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany &&
                                this.companyId !== i.idCompanySource
                            ) {
                                i.customerSourceName = "";
                            }
                        } else {
                            i.customerSourceName = "";
                        }
                    });
                }
            } else {
                if (this.completedTransformations) {
                    await this.getTransformations();
                }
            }

            this.completedTransformations = completedTransformations;
        } finally {
            this.overlay = false;
        }
    }

    async transformationChanged(transformation: ITransformations) {
        this.overlay = true;
        try {
            if (transformation !== undefined && Object.keys(transformation).length !== 0) {
                this.selectedTransformation = transformation;
                this.enableTabsItemTransformation = true;
                this.idTransformation = transformation.id;
                this.enableTabsItem = true;

                await this.getInboundStock();
                await this.getTransformationsPalletsSource();
                await this.getTransformationsPalletsDestination();
                this.createTransformationDestinationHeaders();
            } else {
                this.enableTabsItemTransformation = false;
                this.idTransformation = "";
                this.activeTab = 0;
                this.enableTabsItem = false;
            }
        } finally {
            this.overlay = false;
        }
    }

    createTransformationDestinationHeaders() {
        this.productsTransformationList = [];

        if (this.transformationPalletsDestinationList.length > 0) {
            this.transformationPalletsDestinationList.forEach(p => {
                const transformationPalletsSource = this.transformationPalletsSourceList.filter(
                    t => t.idTransformation === p.idTransformation && t.idGood === p.idGood
                );

                const index = this.productsTransformationList.findIndex(t => t.idGood === p.idGood);

                if (index === -1) {
                    const product: ITransformationsProducts = {
                        id: uuidv4(),
                        idGood: p.idGood,
                        goodName: p.goodName,
                        totalCasesAvailable: transformationPalletsSource.reduce(
                            (sum, current) => Number(sum) + Number(current.totalCases),
                            0
                        ),
                        totalCasesInUse: p.casesPerPallet * p.palletAmount,
                        palletsSource: [],
                        goodsPerCase: p.goodsPerCase
                    };
                    this.productsTransformationList.push(product);
                } else {
                    this.productsTransformationList[index].totalCasesInUse =
                        this.productsTransformationList[index].totalCasesInUse +
                        (p.casesPerPallet * p.palletAmount);
                }
            });
        }

        return this.productsTransformationList;
    }

    async saveTransformation(transformation: ITransformations) {
        const id = await this.transformationApi.SaveTransformation(transformation);
        if (id) {
            transformation.id = id;
            this.transformationList = [transformation].concat(this.transformationList);
            this.selectedTransformation = transformation;
            this.showMessageInfo(`The transformation has been successfully saved`);
        } else {
            const errors: string = this.transformationApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async completeTransformation(transformationId: string) {
        if (!transformationId) return;

        if (this.isTransformationBeingCompleted(transformationId)) {
            return;
        }

        try {
            this.lockTransformationCompletion(transformationId);

            const response = await this.transformationApi.CompleteTransformation(transformationId);
            if (response) {
                this.showMessageInfo(`The transformation has been successfully completed`);
            }
        } finally {
            this.unlockTransformationCompletion(transformationId);
        }
    }

    CheckIfProductHasNotAvailableCases(products: ITransformationsProducts[]): boolean {
        return products.some(item => item.totalCasesAvailable !== item.totalCasesInUse);
    }

    async editTransformation(
        transformation: ITransformations,
        done?: (r: { success: boolean; transformation?: ITransformations }) => void
    ) {
        if (this.isEditingTransformation) {
            return;
        }

        const transformationId = transformation ? transformation.id : "";

        try {
            this.isEditingTransformation = true;
            this.overlay = true;

            const completedId = this.StatusTransformationCompleted;
            const isTryingToSetCompleted =
                ((transformation.statusName || "").toLowerCase() === "completed") ||
                (completedId !== "" && transformation.idListStatusTransformation === completedId);

            if (isTryingToSetCompleted && this.isTransformationBeingCompleted(transformationId)) {
                return;
            }

            if (isTryingToSetCompleted) {
                if (!confirm("Are you sure you want to complete this transformation?")) {
                    await this.getTransformations();
                    const original = this.transformationList.find(t => t.id === transformation.id);
                    if (original) {
                        this.selectedTransformation = original;
                    }
                    if (done) done({ success: false, transformation: original });
                    return;
                }

                if (this.CheckIfProductHasNotAvailableCases(this.productsTransformationList)) {
                    this.showMessageWarning(
                        "The transformation cannot be completed, some of the pallets to be transformed have boxes not assigned to a pallet."
                    );

                    await this.getTransformations();
                    const original = this.transformationList.find(t => t.id === transformation.id);
                    if (original) {
                        this.selectedTransformation = original;
                    }

                    if (done) done({ success: false, transformation: original });
                    return;
                }

                if (
                    this.transformationPalletsDestinationList.length === 0 ||
                    this.transformationPalletsSourceList.length === 0
                ) {
                    this.showMessageWarning(
                        "The transformation cannot be completed. Check the source pallets and the destination pallets to ensure that all the source material is properly transformed and that the total number of boxes is correct."
                    );

                    await this.getTransformations();
                    const original = this.transformationList.find(t => t.id === transformation.id);
                    if (original) {
                        this.selectedTransformation = original;
                    }

                    if (done) done({ success: false, transformation: original });
                    return;
                }

                transformation.dateTransform = new Date();
                this.lockTransformationCompletion(transformationId);
            }

            const result: boolean = await this.transformationApi.UpdateTransformation(transformation);
            if (!result) {
                const errors: string = this.transformationApi.getModelError().join("; ");
                this.showMessageError(errors || "Error updating transformation.");
                if (done) done({ success: false });
                return;
            }

            if (isTryingToSetCompleted) {
                const response = await this.transformationApi.CompleteTransformation(transformation.id);
                if (response) {
                    this.showMessageInfo(`The transformation has been successfully completed`);
                }
            }

            await this.getTransformations();

            const reselect = this.transformationList.find(t => t.id === transformation.id);
            if (reselect) {
                this.selectedTransformation = reselect;
                await this.transformationChanged(reselect);
            }

            this.showMessageInfo("The transformation has been successfully edited");

            if (done) done({ success: true, transformation: reselect || transformation });
        } catch (e) {
            console.error("Error updating transformation:", e);
            this.showMessageError("Error updating transformation.");
            if (done) done({ success: false });
        } finally {
            if (transformationId) {
                this.unlockTransformationCompletion(transformationId);
            }
            this.isEditingTransformation = false;
            this.overlay = false;
        }
    }

    canEditTransformation(editedTransformation: ITransformations): boolean {
        let canEdit = true;
        if ((editedTransformation.statusName || "").toLowerCase() === 'completed') {
            canEdit = false;
        }
        return canEdit;
    }

    deleteTransformation(item: ITransformations) {
        confirm('Are you sure you want to delete this transformation?') &&
            this.deleteTransformationItem(item);
    }

    async deleteTransformationItem(transformation: ITransformations) {
        const resultDeleteTransformationDestination =
            await this.transformationPalletsDestinationApi.DeleteTransformationPalletDestinationByTransformationId(transformation.id);

        if (resultDeleteTransformationDestination === false) {
            const errors: string = this.transformationPalletsDestinationApi.getModelError().join("; ");
            this.showMessageError(errors);
            return;
        }

        const resultDeleteTransformationSource =
            await this.transformationPalletsSourceApi.DeleteTransformationPalletSourceByTransformationId(transformation.id);

        if (resultDeleteTransformationSource === false) {
            const errors: string = this.transformationPalletsSourceApi.getModelError().join("; ");
            this.showMessageError(errors);
            return;
        }

        this.transformationPalletsDestinationList = [];
        this.transformationPalletsSourceList = [];

        const result: boolean = await this.transformationApi.DeleteTransformation(transformation.id);
        if (result) {
            const index = this.transformationList.indexOf(transformation);
            if (index !== -1) {
                this.transformationList.splice(index, 1);
            }
            this.showMessageInfo(`The transformation has been successfully deleted`);
        } else {
            const errors: string = this.transformationApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async saveTransformationPalletDestination(item: ITransformationsPalletsDestination, stockSource: IStock[]) {
        if (!this.selectedTransformation) return;

        item.idTransformation = this.selectedTransformation.id;

        const id = await this.transformationPalletsDestinationApi.SaveTransformationPalletsDestination(item);
        if (id) {
            item.id = id;
            this.transformationPalletsDestinationList = [item].concat(this.transformationPalletsDestinationList);
            this.showMessageInfo(`The transformation has been successfully saved`);
            await this.saveTransformationPalletSource(stockSource, id);
            this.createTransformationDestinationHeaders();
        } else {
            const errors: string = this.transformationPalletsDestinationApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async saveTransformationPalletSource(items: IStock[], idTransformationPalletDestination: string) {
        for (const p of items) {
            const transformationSource = this.mapToTransformationPalletSource(p, idTransformationPalletDestination);

            if (!this.existTransformationPalletSource(transformationSource)) {
                const id = await this.transformationPalletsSourceApi.SaveTransformationPalletsSource(transformationSource);
                if (id) {
                    transformationSource.id = id;
                    this.transformationPalletsSourceList = [transformationSource].concat(this.transformationPalletsSourceList);
                } else {
                    const errors: string = this.transformationPalletsSourceApi.getModelError().join("; ");
                    this.showMessageError(errors);
                }
            }
        }
    }

    existTransformationPalletSource(transformationSource: ITransformationsPalletsSource): boolean {
        const index = this.transformationPalletsSourceList.findIndex(i =>
            i.idGood === transformationSource.idGood &&
            i.idPallet === transformationSource.idPallet &&
            i.idInboundDeliveryNoteDetail === transformationSource.idInboundDeliveryNoteDetail &&
            i.idListPallet === transformationSource.idListPallet &&
            i.idTransformation === transformationSource.idTransformation
        );

        return index !== -1;
    }

    mapToTransformationPalletSource(item: IStock, idTransformationDestination: string) {
        const indexListPallet = this.listPalletTypes.findIndex(l => l.name === item.listPalletName);

        const transformationSource: ITransformationsPalletsSource = {
            id: "",
            idGood: item.idGood,
            goodName: item.goodName,
            idPallet: item.idPallet,
            idInboundDeliveryNoteDetail: item.idInboundDeliveryNoteDetail,
            idListPallet: indexListPallet !== -1 ? this.listPalletTypes[indexListPallet].id : "",
            palletType: item.listPalletName,
            totalCases: item.totalCases,
            goodsPerCase: item.goodsPerCase,
            idTransformation: this.selectedTransformation ? this.selectedTransformation.id : ""
        };

        return transformationSource;
    }

    deleteTransformationPalletsDestination(item: ITransformationsPalletsDestination, showConfirmation: boolean) {
        if (showConfirmation) {
            if (confirm('Are you sure you want to delete this transformation?')) {
                this.deleteTransformationPalletDestinationItem(item);
            }
        } else {
            this.deleteTransformationPalletDestinationItem(item);
        }
    }

    async deleteTransformationPalletDestinationItem(transformationDestination: ITransformationsPalletsDestination) {
        const result: boolean =
            await this.transformationPalletsDestinationApi.DeleteTransformationPalletDestination(transformationDestination.id);

        if (!result) {
            const errors: string = this.transformationPalletsDestinationApi.getModelError().join("; ");
            this.showMessageError(errors);
            return;
        }

        const index = this.transformationPalletsDestinationList.indexOf(transformationDestination);
        if (index !== -1) {
            this.transformationPalletsDestinationList.splice(index, 1);
        }

        const transformationPalletsDestinationWithSameGood = this.transformationPalletsDestinationList.find(
            i => i.idGood === transformationDestination.idGood &&
                 i.goodsPerCase === transformationDestination.goodsPerCase
        );

        if (transformationPalletsDestinationWithSameGood === undefined && this.selectedTransformation) {
            const resultDeleteSource: boolean =
                await this.transformationPalletsSourceApi.DeleteTransformationPalletSourceByTransformationIdAndGoodId(
                    this.selectedTransformation.id,
                    transformationDestination.idGood,
                    transformationDestination.goodsPerCase
                );

            if (resultDeleteSource) {
                await this.getTransformationsPalletsSource();
                this.createTransformationDestinationHeaders();
            } else {
                const errors: string = this.transformationPalletsSourceApi.getModelError().join("; ");
                this.showMessageError(errors);
                return;
            }
        }

        this.createTransformationDestinationHeaders();
        this.showMessageInfo(`The transformation has been successfully deleted`);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
